import React, { PureComponent } from 'react'
import { connect } from 'react-redux'
import AuthActions from 'store/redux/auth'

@connect(
    null,
    {
        signout: AuthActions.signout
    }
)
export class Signout extends PureComponent {
    componentWillMount() {
        this.props.signout()
    }
    render() {
        return null
    }
}



// WEBPACK FOOTER //
// src/pages/Signout/Signout.js